import React from "react";

import { CButton } from "@coreui/react";
import { RiGitBranchLine } from "react-icons/ri";

import URL from "../../config/api";
import { friendlyDate } from "../../utils/date";

const DashboardTrailItem = ({ item, className }) => {
  const to = `/trail/do/${item.trail_allocation_id}/activity/${item.id}`;

  return (
    <CButton
      to={to}
      color="white"
      className={`p-0 d-flex w-100 border-default ${className || ""}`}
    >
      <div className="d-flex align-items-center w-100" target="_blank">
        <div
          className="d-flex align-items-center rounded-left justify-content-center text-white bg-primary"
          style={{ height: "5rem", width: "5rem", fontSize: "2.25rem" }}
        >
          <RiGitBranchLine />
        </div>
        <div
          className="flex-1 d-flex align-items-center text-ellipsis px-4"
          style={{ fontSize: "1rem" }}
        >
          <div
            className="d-none d-lg-flex align-items-center text-left mr-4"
            style={{ flex: 1, fontWeight: "bold" }}
          >
            <div className="c-avatar mr-3">
              <img
                className="c-avatar-img"
                alt=""
                src={
                  URL.img +
                  (item.user.photo || "uploads/users/profileEmpty.jpg")
                }
              />
            </div>
            <span className="text-wrap m-0">{item.user.name}</span>
          </div>
          <div className="d-flex flex-column text-ellipsis" style={{ flex: 2 }}>
            <div
              className="text-ellipsis text-left"
              style={{ flex: 1, fontWeight: "bold" }}
            >
              {item.name}
            </div>
            <div
              className="text-muted text-ellipsis text-left small"
              style={{ flex: 1 }}
            >
              {item.activity_end
                ? `
              Acaba em ${friendlyDate(item.activity_end)}`
                : "Para fazer a qualquer momento"}
            </div>
          </div>
        </div>
      </div>
    </CButton>
  );
};

export default DashboardTrailItem;
